import { ExpandableListCell } from './expandable-list-cell.model';

export class ExpandableListItem {
    id: number;
    order?: number;
    displayValue: string;
    cells: ExpandableListCell[];
    groupby?: string;
}
